import { Navigate } from 'react-router-dom';
import { usePermissions } from '../contexts/PermissionsContext';

// Post-login landing redirect. Each role lands on the dashboard most
// relevant to their day-to-day work so they don't have to hunt for it.
// Order matters — first match wins. CEO sees the executive view; an
// HR-only user lands on HR; a recruiter lands on recruiting; everyone
// else gets the generic dashboard.
export default function RoleLanding() {
  const { roles, has, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', color: 'var(--text-muted)', fontSize: 13 }}>
        Loading…
      </div>
    );
  }

  if (roles.includes('ceo') || has('ceo.private_tasks') || has('ceo.executive_strategy')) {
    return <Navigate to="/ceo-dashboard" replace />;
  }
  if (roles.includes('hr') || (has('hr.view') && !has('candidates.view'))) {
    return <Navigate to="/hr-dashboard" replace />;
  }
  if (roles.includes('recruiter') || has('candidates.view')) {
    return <Navigate to="/recruiting-dashboard" replace />;
  }
  if (roles.includes('admin') || roles.includes('manager')) {
    return <Navigate to="/management-dashboard" replace />;
  }

  return <Navigate to="/dashboard" replace />;
}
